import { render, staticRenderFns } from "./TestTreeForm.vue?vue&type=template&id=2239630a"
import script from "./TestTreeForm.vue?vue&type=script&lang=js"
export * from "./TestTreeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2239630a')) {
      api.createRecord('2239630a', component.options)
    } else {
      api.reload('2239630a', component.options)
    }
    module.hot.accept("./TestTreeForm.vue?vue&type=template&id=2239630a", function () {
      api.rerender('2239630a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/tree/TestTreeForm.vue"
export default component.exports